import axios, { AxiosRequestConfig, AxiosError } from "axios";
import configUrl from "src/util/config";
import { getCookieValue, removeCookieValue } from "./Commom";
import { MessageStatusError, MessageStatusSuccess } from "./MessageStatus";
import { isEmpty } from "lodash";

interface ApiConfig {
  url: string;
  method: string;
  data?: any;
  params?: any;
  isShowMessage?: boolean;
  apiType?: string;
  getName?: string;
  // Thêm các thuộc tính khác của cấu hình nếu cần
}

interface ApiCall {
  [key: string]: any;
}

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  apiType?: string;
  isShowMessage?: boolean;
  getName?: string;
}

const axiosClient = axios.create({
  headers: {
    "content-type": "application/json",
  },
  baseURL: configUrl.API_URL,
});

axiosClient.interceptors.request.use((config) => config);

let isExpired = true;

axiosClient.interceptors.response.use(
  async (response) => {
    const { status, config } = response;
    const { isShowMessage, apiType } = config as unknown as {
      isShowMessage: boolean;
      apiType: string;
    }; // Sử dụng TypeScript assertion để đảm bảo config chứa thuộc tính isShowMessage và apiType

    if (status === 401 && isExpired) {
      isExpired = false;
      MessageStatusError(status);
      await removeCookieValue("accessTokenTVDTBDT");
      setTimeout(() => {
        window.location.href = `${configUrl.API_URL}/saml/logout?url=${window.location.protocol}//
              ${window.location.host}${window.location.hash}`;
      }, 1500);
    }
    if (isShowMessage) {
      if (status === 200 || status === 201) {
        // Hiển thị thông báo thành công
        MessageStatusSuccess(apiType);
      } else {
        // Hiển thị thông báo lỗi
        MessageStatusError(status);
      }
    }
    return response;
  },
  (error: AxiosError) => {
    // Xử lý lỗi
    if (error.response && error.response.status === 401) {
      // Thực hiện logout người dùng và xử lý logic logout ở đây
      MessageStatusError(401);
      removeCookieValue("accessTokenTVDTBDT");
      setTimeout(() => {
        window.location.href = `${configUrl.API_URL}/saml/logout?url=${window.location.protocol}//${window.location.host}${window.location.hash}`;
      }, 1500);
    }
    return Promise.reject(error);
  }
);

export const call: ApiCall = {};

export const apiCaller = (configAPI: ApiConfig) => {
  const accessToken = getCookieValue("accessTokenTVDTBDT");
  const {
    url,
    data,
    params,
    isShowMessage = true,
    apiType,
    getName,
  } = configAPI;
  const options: CustomAxiosRequestConfig = {
    method: configAPI.method,
    isShowMessage,
    apiType,
    url,
    data,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
      Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
    },
    params,
    getName,
  };
  if (getName) {
    call[getName] = axios.CancelToken.source();
    return axiosClient({
      ...options,
      cancelToken: call[getName].token,
    }).catch((err: AxiosError) => err.response);
  } else {
    return axiosClient({
      ...options,
    }).catch((err: AxiosError) => err.response);
  }
};

export const cancelListToken = (listNameCancel: any) => {
  if (listNameCancel.length > 0) {
    listNameCancel.forEach((name: any) => {
      if (!isEmpty(call[name])) {
        call[name].cancel();
      }
    });
  }
};
